import { Component, OnInit, NgZone, ViewChild, ElementRef, HostListener } from '@angular/core';
import { getDeviceSize } from 'src/app/utilities/utilities.file';
import { HEADER_SECTION } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';
import { SharedServiceService } from '../../services/shared-service.service';


@Component({
  selector: 'app-headersection',
  templateUrl: './headersection.component.html',
  styleUrls: ['./headersection.component.scss']
})
export class HeadersectionComponent implements OnInit {
  isMobile: boolean;
  breakpoint: number;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');

  @ViewChild('stickyPanel') stickeyElement: ElementRef;
  sticky = false;
  elementPosition: any; 
  header_section: any;

  constructor(
    private ngZone: NgZone,
    private sharedService: SharedServiceService,
    private themeService: ThemeService
  ) { 
    this.partnerCode = this.themeService.partnerCode;
  }
  ngOnInit() {

    this.header_section = HEADER_SECTION;

    if (getDeviceSize() === 'small') {
      this.isMobile = true;

    }

    window.onresize = (e) => {
      this.ngZone.run(() => {
        if (getDeviceSize() === 'small') {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      })
    }
   
  }


 

  ngAfterViewInit() {
    this.elementPosition = this.stickeyElement.nativeElement.getBoundingClientRect().top; 
    }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    this.sticky = (window.pageYOffset >= this.elementPosition);
  }

}
